import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2a35194"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "img-wrapper position-relative" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "tl-badges position-absolute d-flex" }
const _hoisted_5 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-alt-to-bottom" })
], -1))
const _hoisted_7 = ["data-bs-toggle", "data-bs-title"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" })
], -1))
const _hoisted_9 = { class: "tr-badges position-absolute top-rating-badge px-2 py-1 rounded-1 shadow-sm" }
const _hoisted_10 = { class: "br-badges position-absolute author-badge px-2 py-1 rounded-1 shadow-sm" }
const _hoisted_11 = { class: "game-logo position-absolute" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_15 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.previewPic(_ctx.data.img),
        class: "item-pic card-img-top position-relative",
        alt: _ctx.data.title
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "downloads-badge px-2 py-1 rounded-1 me-2 shadow-sm",
          "data-bs-toggle": `tooltip-${_ctx.data.id}`,
          "data-bs-placement": "top",
          "data-bs-title": _ctx.getStringDownloads(_ctx.data.downloads)
        }, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(_ctx.getEyeCandyNum(_ctx.data.downloads)), 1)
        ], 8, _hoisted_5),
        _createElementVNode("div", {
          class: "rating-badge px-2 py-1 rounded-1 shadow-sm",
          "data-bs-toggle": `tooltip-${_ctx.data.id}`,
          "data-bs-placement": "top",
          "data-bs-title": _ctx.getStringLikes(_ctx.data.likes)
        }, [
          _hoisted_8,
          _createTextVNode(_toDisplayString(_ctx.getEyeCandyNum(_ctx.data.likes)), 1)
        ], 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "tr-badge", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_10, " Автор: " + _toDisplayString(_ctx.data.author), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          alt: "game-logo",
          src: _ctx.itemGameLogo(_ctx.data.game)
        }, null, 8, _hoisted_12)
      ]),
      _createVNode(_component_router_link, {
        to: { name: 'mod', params: { game: _ctx.data.game, slug: _ctx.data.slug }},
        class: "img-wrapper_action position-absolute"
      }, null, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_router_link, {
          to: { name: 'mod', params: { game: _ctx.data.game, slug: _ctx.data.slug }},
          class: "card-link text-wrap"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.sliceTitle(_ctx.data.title)), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          tag: "button",
          to: { name: 'mod', params: { game: _ctx.data.game, slug: _ctx.data.slug }},
          class: "btn btn-card px-3 py-0 text-nowrap"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Открыть ")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", {
        class: "description-md no-style pt-3 text-brake",
        innerHTML: _ctx.getDesc
      }, null, 8, _hoisted_15)
    ])
  ]))
}